'use client';
import Image from 'next/image';
import styles from './CartItems.module.css';

export default function CartItems({ items, onUpdateQuantity, onRemove }) {
  return (
    <div className={styles.itemsList}>
      {items.map((item) => (
        <div key={item.id} className={styles.item}>
          <div className={styles.imageContainer}>
            <Image 
              src={item.image} 
              alt={item.name}
              width={100}
              height={100}
              unoptimized
            />
          </div>

          <div className={styles.details}>
            <div className={styles.info}>
              <h3 className={styles.name}>{item.name}</h3>
              <p className={styles.variant}>{item.variant}</p>
            </div>

            <div className={styles.actions}>
              <div className={styles.quantity}>
                <button
                  onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                  className={styles.quantityBtn}
                  aria-label="Decrease quantity"
                >
                  −
                </button>
                <span className={styles.quantityValue}>{item.quantity}</span>
                <button
                  onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                  className={styles.quantityBtn}
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>

              <p className={styles.price}> DT{(item.price * item.quantity).toFixed(2)}</p>

              <button
                onClick={() => onRemove(item.id)}
                className={styles.removeBtn}
                aria-label="Remove item"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
